import { Editor as ProPageEditor } from '@page-creator/context';

export const Editor = ProPageEditor;
